import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface CompletionToggleProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  colorClassName?: string;
}
export function CompletionToggle({
  checked,
  onChange,
  label,
  colorClassName = 'bg-teal-600 border-teal-600'
}: CompletionToggleProps) {
  return <motion.button type="button" role="checkbox" aria-checked={checked} aria-label={label} onClick={onChange} whileTap={{
    scale: 0.9
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 transition-colors duration-150 ${checked ? colorClassName : 'border-slate-300 bg-white'}`} data-id="element-139" data-mp="18jp85q1buygb">
      {checked && <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} data-id="element-140" data-mp="3oc4lvq5a4k5c" />}
    </motion.button>;
}